import parseApiV2Response from '../v2/parseApiV2Response';

/**
 * @param {object} response
 * @param {Array<moment>} dates
 * @param {object} state
 */
// At the moment, the version 3 response is identical to the version 2 response
export default parseApiV2Response;
